import { uniform } from 'three/tsl';

// Shared mip-bias uniform for textured surfaces that opt into TAAU-aware
// sampling. SfxWebGPU's setRenderScale() drives this to log2(renderScale) when
// upscaling (so the GPU picks sharper mips matching the lower input pixel
// rate) and back to 0 at native. Materials sample via `texNode.bias(...)`.
export const taauMipBiasUniform = uniform(0);
